<template>
    <p class="relative w-full flex flex-column">
        <skeleton v-for="line in lines" :key="line" :height="height" class="w-full" :class="[line !== lines ? 'mb-' + textSpacing : '']" rounded />
    </p>
</template>

<script>
import Sizeable from "../../mixins/Sizeable";

    export default {
        name: 'ParagraphSkeleton',

        mixins: [Sizeable],

        props: {
            lines: {
                type: Number,
                default: 1
            },

            spacing: {
                default: null,
                type: [String, Number],
            }
        },

        computed: {
            height() {
                switch (this.sizeString) {
                    case "xs":
                        return '12px';
                    case "sm":
                        return '13px';
                    case "lg":
                        return '21px';
                    case "xl":
                        return '23px';
                }
                return '16px';
            },

            textSpacing() {
                if (this.spacing) {
                    return this.spacing;
                }
                switch (this.sizeString) {
                    case "xs":
                        return 6;
                    case "sm":
                        return 8;
                    case "lg":
                        return 12;
                    case "xl":
                        return 14;
                }
                return 10;
            }
        }
    }
</script>

